import React from "react";
import { s3baseUri } from "../../../config/config";
import { banner_png, noImagePlaceholder } from "../../../assets";
import { Chip } from "@mui/material";

const AffiliateCard = ({
  client,
  handleNavigateDetails = () => {},
  width = "100%",
  height = "100%",
  showAdditionalButton = false,
  additionButton = null,
  chipValue = null,
  chipColor = "info",
}) => {
  return (
    <div
      className="card-1 client-img-card"
      style={{ width, height }}
      onClick={() => handleNavigateDetails(client)}
    >
      {client?.cover_photo?.thumbnail_1 ? (
        <img
          src={s3baseUri + client?.cover_photo?.thumbnail_1}
          className="card-banner-img"
          alt=""
        />
      ) : (
        <div
          className="card-banner-img w-100"
          style={{ background: "#ccc", height: 90 }}
        />
      )}

      <img
        className="card-profile-img"
        src={
          client?.profile_image?.thumbnail_2
            ? s3baseUri + client?.profile_image?.thumbnail_2
            : s3baseUri + client?.profile_image?.thumbnail_1
        }
        alt={client.company_name}
        onError={(e) => {
          e.target.src = noImagePlaceholder;
        }}
      />

      <div className="mt-5 text-center mb-4">
        <div className="company-name">{client.company_name}</div>
        {showAdditionalButton && additionButton}
      </div>

      {chipValue && (
        <Chip
          label={chipValue}
          variant="contained"
          className={`text-white text-capitalize`}
          color={chipColor}
          size="small"
          sx={{
            position: "absolute",
            zIndex: 1000,
            top: "5px",
            right: "5px",
            "& .MuiChip-label": {
              color: "var(--text-white) !important",
              lineHeight: "1.2",
            },
          }}
        />
      )}
    </div>
  );
};

export default AffiliateCard;
